import React, { useState, useEffect, useContext } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { LanguageContext } from '../contexts/LanguageContext';
import { translations } from '../locales/translations';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { language, toggleLanguage } = useContext(LanguageContext);
  const t = translations[language].nav;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled || location.pathname !== '/' ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-primary">
              Antworers
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-4">
            <div className="flex items-baseline space-x-4">
              <Link 
                to="/" 
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  location.pathname === '/' ? 'text-primary' : 'text-gray-800 hover:text-primary'
                }`}
              >
                {t.home}
              </Link>
              <Link 
                to="/products" 
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  location.pathname === '/products' ? 'text-primary' : 'text-gray-800 hover:text-primary'
                }`}
              >
                {t.products}
              </Link>
              <Link 
                to="/solutions" 
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  location.pathname === '/solutions' ? 'text-primary' : 'text-gray-800 hover:text-primary'
                }`}
              >
                {t.solutions}
              </Link>
              <button className="bg-primary text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-600">
                {t.tryFree}
              </button>
            </div>
            <button 
              onClick={toggleLanguage}
              className="ml-4 px-3 py-1 rounded border border-gray-300 text-sm font-medium hover:bg-gray-50"
            >
              {language === 'en' ? '中文' : 'EN'}
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
